import React from "react";
import { useTranslation } from "react-i18next";
import LanguageSwitcher from "../../../components/LanguageSwitcher";
import { Link, useNavigate } from "react-router-dom";
import Auth from "../../../utils/AuthUtils";


function Header() {
   const { t } = useTranslation();

  const image = Auth.getUserDetails("image");

  const navigate = useNavigate();

  const handleLogOut = () => {
    localStorage.removeItem("admin_token");
    navigate("/admin");
  };

  return (
    <div className="header">
      <div className="header-left active">
        <Link className="logo logo-normal" to="/admin/dashboard">
          <img
            src={`${process.env.PUBLIC_URL}/img/sansad-khel-mahotsav.webp`}
            alt="Logo"
          />
          <img
            src={`${process.env.PUBLIC_URL}/img/sansad-khel-mahotsav.webp`}
            className="white-logo"
            alt="Logo"
          />
        </Link>
        <Link className="logo-small" to="/admin/dashboard">
          <img
            src={`${process.env.PUBLIC_URL}/img/sansad-khel-mahotsav.webp`}
            alt="Logo"
          />
        </Link>

        <span id="toggle_btn">
          <i className="ti ti-arrow-bar-to-left" />
        </span>
      </div>
      {/* /Logo */}
      <a id="mobile_btn" className="mobile_btn" href="#sidebar">
        <span className="bar-icon">
          <span />
          <span />
          <span />
        </span>
      </a>
      <div className="header-user">
        <ul className="nav user-menu">
          {/* Search */}
          <li className="nav-item nav-search-inputs me-auto">{t("title")}</li>
          {/* /Search */}
          <li className="nav-item nav-list">
            <ul className="nav">
              <li>
                <div>
                  <a
                    href="#"
                    className="btn btn-icon border btn-menubar btnFullscreen"
                  >
                    <i className="ti ti-maximize" />
                  </a>
                </div>
              </li>

              <LanguageSwitcher />
            </ul>
          </li>
          {/* /Nav List */}
          {/* Profile Dropdown */}
          <li className="nav-item dropdown has-arrow main-drop">
            <a href="#" className="nav-link userset" data-bs-toggle="dropdown">
              <span className="user-info">
                <span className="user-letter">
                  <img
                    src={image || `${process.env.PUBLIC_URL}/img/user-dummy.jpg`}
                    alt="Profile"
                  />
                </span>
                <span className="badge badge-success rounded-pill" />
              </span>
            </a>
            <div className="dropdown-menu menu-drop-user">
              <div className="profilename">
                <Link to="/admin/my-profile" className="dropdown-item">
                  <i className="ti ti-layout-2" />{t('my_profile')}
                </Link>
                <Link to="/admin/change-password" className="dropdown-item">
                  <i className="ti ti-user-pin" /> {t('change_password')}
                </Link>
                <span onClick={handleLogOut} className="dropdown-item">
                  <i className="ti ti-lock" /> {t('logout')}
                </span>
              </div>
            </div>
          </li>
          {/* /Profile Dropdown */}
        </ul>
      </div>
      {/* Mobile Menu */}
      <div className="dropdown mobile-user-menu">
        <span
          className="nav-link dropdown-toggle"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          <i className="fa fa-ellipsis-v" />
        </span>
        <div className="dropdown-menu">
          <Link to="/admin/my-profile" className="dropdown-item">
            <i className="ti ti-layout-2" /> {t('my_profile')}
          </Link>
          <Link to="/admin/change-password" className="dropdown-item">
            <i className="ti ti-user-pin" /> {t('change_password')}
          </Link>
          <span onClick={handleLogOut} className="dropdown-item">
            <i className="ti ti-lock" /> {t('logout')}
          </span>
        </div>
      </div>
      {/* /Mobile Menu */}
    </div>
  );
}

export default Header;